// import React, { useEffect, useState } from "react"
// import '../styles/user_management_styles.css'
// import Navbar from "./Navbar.js"
// import 'bootstrap/dist/css/bootstrap.min.css';
// import Axios from "axios";
// import config from '../config.js';
// import RoleTable from "./tables/RoleTable";
// import UserTable from "./tables/UserTable";
// import swal from 'sweetalert';
// import { FormControl, MenuItem, Select } from "@mui/material";
// import Cookies from "universal-cookie";
// import mixpanel from "mixpanel-browser";

// const PermissionsAssign = () => {
//     const [selectedRole, setSelectedRole] = useState([]);
//     const [selectedUser, setSelectedUser] = useState([]);
//     const [defaultRole, setDefaultRole] = useState("");
//     const cookies = new Cookies();
//     let actionInitiatingUser = -1;
//     let userToken = "";
//     try {
//         actionInitiatingUser = cookies.get('userID');
//         userToken = cookies.get('userToken');
//     } catch (error) {}
//     const headers = {
//         'Authorization': `Bearer ${userToken}`,
//         'Content-Type': 'application/json'
//     };

//     useEffect((()=>{
//     }),[selectedRole, selectedUser]);

//     const handleChange = (event) => {
//         setDefaultRole(event.target.value);
//     };
//     const Assign = () =>{
//         mixpanel.track("Assign Role Page Assign Button Clicked", { userID: cookies.get('userID') });
//         if (selectedRole.length === 1 && defaultRole!="") {
//             swal("You can't assign two role to user", "Please try again", "error");
//         } else {
//             if(selectedRole.length === 0 && defaultRole !== "" && selectedUser.length>0){
//                 swal("Are you sure you want to update the user with this role?", "", "warning", {
//                     buttons: {
//                         cancel: "Cancel",
//                         catch: {
//                             text: "Assign",
//                             value: "assign",
//                         },
//                     },
//                 }).then(value => {
//                     if(value==="assign"){
//                         Axios.post(config.BACKEND_URL + '/permissions/default/assign', {defaultRole, selectedUser, actionInitiatingUser}, { headers }).then(res=>{
//                             if(res.status==200){
//                                 swal("Role Added", "Role Added to the users", "success").then(() => {
//                                     window.location.reload();
//                                 });
//                             }
//                         }).catch(err => {
//                             console.log(err);
//                         });
//                     }
//                 });
//                 return;
//             }
//         }
//         if(selectedRole.length === 1 && selectedUser.length>0 && defaultRole === ""){
//             swal("Are you sure you want to update the user with this role?", "", "warning", {
//                 buttons: {
//                     cancel: "Cancel",
//                     catch: {
//                         text: "Assign",
//                         value: "assign",
//                     },
//                 },
//             }).then(value => {
//                 if(value==="assign"){
//                     Axios.post(config.BACKEND_URL + '/permissions/assign', {selectedRole, selectedUser, actionInitiatingUser}, { headers }).then(res=>{
//                         if(res.status==200){
//                             swal("Role Added", "Role Added to the user", "success").then(() => {
//                                 window.location.reload();
//                             });
//                         }
//                     }).catch(err => {
//                         console.log(err);
//                     });
//                 }
//             });
//         } else {
//             swal("One role can be assign to one or more user", "Please try again", "error");
//         }
//     }
//     return (
//         <div className="Reports">
//             <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
//                 rel="stylesheet" />
//             <script src='bootstrap/dist/js/bootstrap.min.js'></script>
//             <Navbar />
//             <main className="container-fluid">
//                 <header className="h1 text-center" style={{paddingTop: '1rem'}}>Assign Role and Permissions</header>
//                 <div className="d-flex row justify-content-center">
//                     <div className="col-lg-9 col-md-12">
//                         <RoleTable  selectedRole={selectedRole} setSelectedRole={setSelectedRole} editButton={false} deleteButton={false} />
//                     </div>
//                     <div className="col-lg-3 col-md-12 d-flex flex-column align-items-center">
//                         <h4 className="text-center">Assign role</h4>
//                         <FormControl style={{minWidth: '200px', margin: '1rem 0'}} variant="standard">
//                             <Select displayEmpty renderValue={defaultRole !== "" ? undefined : () => "Default Roles"} id="grouped-select" value={defaultRole} onChange={handleChange} style={{background:'#fff', textAlign: 'center', borderRadius: '10px'}}>
//                                 <MenuItem value=""><em>None</em></MenuItem>
//                                 <MenuItem value="Admin">Admin</MenuItem>
//                                 <MenuItem value="Manager">Manager</MenuItem>
//                                 <MenuItem value="Supervisor">Supervisor</MenuItem>
//                                 <MenuItem value="User">User</MenuItem>
//                                 <MenuItem value="Guest">Guest</MenuItem>
//                             </Select>
//                         </FormControl>
//                         <button className="btn btn-primary" type="submit" onClick={Assign}>  Assign </button>
//                     </div>

//                 </div>
//                 <div className="d-flex row " style={{padding: "0"}}>
//                     <div className="col-lg-9 col-md-12" style={{padding: "0"}}>
//                         <UserTable selectedUser={selectedUser} setSelectedUser={setSelectedUser} />
//                     </div>
//                 </div>
//             </main>
//         </div >
//     );
// }

// export default PermissionsAssign;
import React, { useEffect, useState } from "react";
import "../styles/user_management_styles.css";
import Navbar from "./Navbar.js";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "axios";
import config from "../config.js";
import RoleTable from "./tables/RoleTable";
import UserTable from "./tables/UserTable";
import swal from "sweetalert";
import {
  FormControl,
  MenuItem,
  Select,
  Box,
  Typography,
  Card,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import Cookies from "universal-cookie";
import mixpanel from "mixpanel-browser";
import { UserCheck, ShieldCheck, ChevronRight } from "lucide-react";

const PermissionsAssign = () => {
  const [selectedRole, setSelectedRole] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [defaultRole, setDefaultRole] = useState("");
  const cookies = new Cookies();
  let actionInitiatingUser = -1;
  let userToken = "";
  try {
    actionInitiatingUser = cookies.get("userID");
    userToken = cookies.get("userToken");
  } catch (error) {}
  const headers = {
    Authorization: `Bearer ${userToken}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {}, [selectedRole, selectedUser]);

  const handleChange = (event) => {
    setDefaultRole(event.target.value);
  };

  const Assign = () => {
    mixpanel.track("Assign Role Page Assign Button Clicked", {
      userID: cookies.get("userID"),
    });
    if (selectedRole.length === 1 && defaultRole != "") {
      swal("You can't assign two role to user", "Please try again", "error");
    } else {
      if (
        selectedRole.length === 0 &&
        defaultRole !== "" &&
        selectedUser.length > 0
      ) {
        swal(
          "Are you sure you want to update the user with this role?",
          "",
          "warning",
          {
            buttons: {
              cancel: "Cancel",
              catch: {
                text: "Assign",
                value: "assign",
              },
            },
          }
        ).then((value) => {
          if (value === "assign") {
            Axios.post(
              config.BACKEND_URL + "/permissions/default/assign",
              { defaultRole, selectedUser, actionInitiatingUser },
              { headers }
            )
              .then((res) => {
                if (res.status == 200) {
                  swal("Role Added", "Role Added to the users", "success").then(
                    () => {
                      window.location.reload();
                    }
                  );
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        });
        return;
      }
    }
    if (
      selectedRole.length === 1 &&
      selectedUser.length > 0 &&
      defaultRole === ""
    ) {
      swal(
        "Are you sure you want to update the user with this role?",
        "",
        "warning",
        {
          buttons: {
            cancel: "Cancel",
            catch: {
              text: "Assign",
              value: "assign",
            },
          },
        }
      ).then((value) => {
        if (value === "assign") {
          Axios.post(
            config.BACKEND_URL + "/permissions/assign",
            { selectedRole, selectedUser, actionInitiatingUser },
            { headers }
          )
            .then((res) => {
              if (res.status == 200) {
                swal("Role Added", "Role Added to the user", "success").then(
                  () => {
                    window.location.reload();
                  }
                );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    } else {
      swal(
        "One role can be assign to one or more user",
        "Please try again",
        "error"
      );
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729", color: "white" }}>
      <Navbar />

      <Box sx={{ p: 12, maxWidth: "1400px", mx: "auto" }}>
        {/* Header Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: "white" }}>
            Assign Role & Permissions
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.6)", mt: 0.5 }}>
            Link specific roles or system defaults to your registered users.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Left Side: Role Table */}
          <Grid item xs={12} lg={9}>
            <Card
              sx={{
                background: "rgba(15, 23, 42, 0.6)",
                backdropFilter: "blur(12px)",
                borderRadius: "16px",
                border: "1px solid rgba(148, 163, 184, 0.15)",
                p: 2,
                mb: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                  px: 1,
                }}
              >
                <ShieldCheck size={20} color="#60a5fa" />
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 600, color: "white" }}
                >
                  1. Select a Role
                </Typography>
              </Box>
              <RoleTable
                selectedRole={selectedRole}
                setSelectedRole={setSelectedRole}
                editButton={false}
                deleteButton={false}
              />
            </Card>

            {/* User Table below */}
            <Card
              sx={{
                background: "rgba(15, 23, 42, 0.6)",
                backdropFilter: "blur(12px)",
                borderRadius: "16px",
                border: "1px solid rgba(148, 163, 184, 0.15)",
                p: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                  px: 1,
                  color: "white",
                }}
              >
                <UserCheck size={20} color="#60a5fa" />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  2. Select Users
                </Typography>
              </Box>
              <UserTable
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
              />
            </Card>
          </Grid>

          {/* Right Side: Assignment Control */}
          <Grid item xs={12} lg={3}>
            <Card
              sx={{
                bgcolor: "#1e293b",
                color: "white",
                borderRadius: "16px",
                border: "1px solid #334155",
                p: 3,
                position: { lg: "sticky" },
                top: { lg: "24px" },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Assignment Hub
              </Typography>
              <Divider sx={{ borderColor: "#334155", mb: 3 }} />

              <Typography variant="body2" sx={{ color: "#94a3b8", mb: 1 }}>
                Or use a Default Role:
              </Typography>

              <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                <Select
                  displayEmpty
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                  value={defaultRole}
                  onChange={handleChange}
                  renderValue={
                    defaultRole !== ""
                      ? undefined
                      : () => (
                          <span style={{ color: "#64748b" }}>
                            Choose Default
                          </span>
                        )
                  }
                  sx={{
                    bgcolor: "#0f1729",
                    color: "white",
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#334155",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#60a5fa",
                    },
                    "& .MuiSvgIcon-root": { color: "#94a3b8" },
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Manager">Manager</MenuItem>
                  <MenuItem value="Supervisor">Supervisor</MenuItem>
                  <MenuItem value="User">User</MenuItem>
                  <MenuItem value="Guest">Guest</MenuItem>
                </Select>
              </FormControl>

              <Box
                sx={{
                  p: 2,
                  bgcolor: "rgba(59, 130, 246, 0.1)",
                  borderRadius: "8px",
                  mb: 3,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{ color: "#60a5fa", display: "block", mb: 1 }}
                >
                  Summary:
                </Typography>
                <Typography variant="body2">
                  {selectedUser.length} Users selected
                </Typography>
                <Typography variant="body2">
                  {selectedRole.length > 0
                    ? `Role: Selected`
                    : defaultRole
                    ? `Role: ${defaultRole}`
                    : "No Role Selected"}
                </Typography>
              </Box>

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={Assign}
                endIcon={<ChevronRight size={18} />}
                sx={{
                  bgcolor: "#3b82f6",
                  "&:hover": { bgcolor: "#2563eb" },
                  py: 1.5,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Assign Role
              </Button>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default PermissionsAssign;
